module.exports = __webpack_public_path__ + "img/integrations-pair-1.92dd78ae.png";